import { sanitizeUrlForAnalytics } from "@/lib/urlPrivacy";

const STORAGE_KEY = "hg_discover_attribution";

export interface DiscoverAttribution {
  landing_url?: string;
  landing_path?: string;
  referrer?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
}

export function captureDiscoverAttribution(): DiscoverAttribution {
  const params = new URLSearchParams(window.location.search);
  const current: DiscoverAttribution = {
    landing_url: sanitizeUrlForAnalytics(window.location.href),
    landing_path: window.location.pathname,
    referrer: sanitizeUrlForAnalytics(document.referrer),
    utm_source: params.get("utm_source") || undefined,
    utm_medium: params.get("utm_medium") || undefined,
    utm_campaign: params.get("utm_campaign") || undefined,
    utm_term: params.get("utm_term") || undefined,
    utm_content: params.get("utm_content") || undefined,
  };

  try {
    const existing = window.localStorage.getItem(STORAGE_KEY);
    if (existing) return JSON.parse(existing) as DiscoverAttribution;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
  } catch {
    // Attribution is best-effort when storage is unavailable.
  }

  return current;
}

export function getDiscoverAttribution(): DiscoverAttribution {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored ? (JSON.parse(stored) as DiscoverAttribution) : captureDiscoverAttribution();
  } catch {
    return captureDiscoverAttribution();
  }
}
